import React from 'react';
import classNames from 'classnames';
import { string } from 'prop-types';

const ContentMessage = ({ message, type, className }) => (
  <div
    className={classNames(
      'content-message',
      className,
      `content-message--${type}`)}
  >
    {message}
  </div>
);

ContentMessage.propTypes = {
  message: string.isRequired,
  className: string,
  type: string,
}

ContentMessage.defaultProps = {
  type: 'default',
  className: '',
}

export default ContentMessage;
